<!--
  Says that this view shows agent approvals: one subject's (its page) or
  every one (Settings). It renders nothing itself: the app's dock
  (RelayNotices), always mounted, shows the cards of the views registered
  here and links to the subject's page for the rest, so no card outlives its view.
-->
<script lang="ts">
  import type { SubjectKey } from '../api/relaySubject';
  import { relayAgents } from '../state/relayAgents.svelte';
  let { subject }: { subject?: SubjectKey } = $props();
  // svelte-ignore state_referenced_locally
  const view = subject ?? 'all';
  $effect(() => relayAgents.show(view));
</script>
